import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledLoginContainer = styled('div')`
  padding: 25px;
  min-height: 100vh;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0;
  font-family: ${(props) => props.theme.fontFamily};

  background-color: ${(props) => props.theme.loginBackgroundColor};

  .image {
    background-image: url('/login-background.jpg');
    background-size: cover;
    background-position: center;
    border-radius: 16px 0 0 16px;
  }

  .information {
    background-color: ${(props) => props.theme.brand01};
    border-radius: 0 16px 16px 0;
    padding: 50px 60px;

    color: ${(props) => props.theme.white};
  }

  .content {
    .ant-form {
      height: 100%;
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 0;

    .information {
      display: none !important;
    }

    .image {
      display: none;
    }

    .content {
      width: 100%;
    }
  }
`;

export const RolesContainer = styled.div`
  min-height: calc(100vh - 50px);
  padding: 60px;

  background-color: ${(props) => props.theme.white};
  color: ${(props) => props.theme.colorText};

  .role-title {
    margin-bottom: 20px;
  }
`;

export const RoleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  height: 140px;
  border: 1px solid ${(props) => props.theme.cardBorder};
  border-radius: 5px;

  cursor: pointer;
  font-size: 14px;

  .ant-image-img {
    height: 40px;
    margin-bottom: 10px;
  }
`;

export const StyledConfirmationPageWrapper = styled.div`
  .content {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    min-width: 100%;
    min-height: 100vh;
    background-image: url('/man-farmland-with-watering-can.png');
    background-size: cover;
    background-position: center;

    .content_inner {
      display: flex;
      align-items: center;
      flex-direction: column;
      padding: 20px;
      height: 545px;
      background-color: ${(props) => props.theme.white};
      font-family: ${(props) => props.theme.fontText};
      border-radius: 6px;
      margin-right: 200px;
      width: 100%;
      max-width: 640px;

      .confirmation-content {
        display: flex;
        align-items: center;
        height: 100%;
      }

      .close-button-wrapper {
        display: flex;
        justify-content: flex-end;
        width: 100%;
        cursor: pointer;
      }

      .title {
        margin: 0;
        margin-bottom: 9px;
        color: ${(props) => props.theme.darkGrayishBlue};
        line-height: 62px;
        font-size: 32px;
        font-weight: 600;
        text-align: center;
      }

      .text {
        margin: 0;
        font-size: 16px;
        line-height: 30px;
        text-align: center;
        color: ${(props) => props.theme.darkGrayishBlue};
      }

      .email {
        display: block;
        margin-bottom: 39px;
        text-align: center;
        font-size: 16px;
        line-height: 30px;
        font-weight: 500;
        color: ${(props) => props.theme.darkGrayishBlue};
      }

      .img {
        display: block;
        margin: 0 auto;
        width: 131px;
        height: 131px;
      }

      @media only screen and (max-width: ${breakpoints.lg}px) {
        width: 100%;
      }
    }
  }

  @media only screen and (max-width: 1100px) {
    .content {
      justify-content: center;
      .content_inner {
        margin-right: 0;
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.sm}px) {
    .content {
      .content_inner {
        height: 100vh;
        padding-top: 35px;
        text-align: center;

        .confirmation-content {
          height: 100%;
        }

        .box {
          display: flex;
          flex-direction: column;
          height: 100vh;
          img {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
  }
`;

export const StyledApproveRegistrationPageWrapper = styled.div`
  .content {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    min-width: 100%;
    min-height: 100vh;
    background-image: url('/man-farmland-with-watering-can.png');
    background-size: cover;
    background-position: center;

    .content_inner {
      display: flex;
      flex-direction: column;
      padding: 20px;
      align-items: center;
      height: 545px;
      background-color: ${(props) => props.theme.white};
      font-family: ${(props) => props.theme.fontText};
      border-radius: 6px;
      margin-right: 200px;
      width: 100%;
      max-width: 640px;

      .close-button-wrapper {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        cursor: pointer;
      }

      .box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
      }

      .ant-spin-container {
        display: flex;
        justify-content: center;
      }

      .title {
        margin: 0;
        margin-bottom: 9px;
        color: ${(props) => props.theme.darkGrayishBlue};
        line-height: 62px;
        font-size: 32px;
        font-weight: 600;
        text-align: center;
      }

      .text {
        margin: 0;
        font-size: 16px;
        line-height: 30px;
        text-align: center;
        color: ${(props) => props.theme.darkGrayishBlue};
      }

      .approve-registration-wrapper-btns {
        display: flex;
        justify-content: center;
        gap: 20px;
        padding-top: 81px;
      }

      .approve-registration-wrapper-btn {
        min-width: 241px;
        min-height: 55px;
        border: 1px solid ${(props) => props.theme.brand01};
        border-radius: 5px;
      }

      .add-business {
        background-color: ${(props) => props.theme.brand01};
        min-width: 241px;
        min-height: 55px;
        border: 1px solid ${(props) => props.theme.brand01};
        border-radius: 5px;
      }

      .add-business:hover {
        background-color: ${(props) => props.theme.white};
        border: 1px solid ${(props) => props.theme.brand02};
      }

      .add-business .text {
        color: ${(props) => props.theme.white};
      }

      .add-business:hover .text {
        color: ${(props) => props.theme.brand02};
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .content {
      .content_inner {
        width: 100%;
      }
    }
  }

  @media only screen and (max-width: 1100px) {
    .content {
      justify-content: center;
      .content_inner {
        margin-right: 0;
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.sm}px) {
    .content {
      .content_inner {
        height: 100vh;

        > .ant-spin-nested-loading {
          width: 90%;
          > .ant-spin-container {
            width: 100%;
          }
        }

        .box {
          display: flex;
          flex-direction: column;
          height: 100vh;
          justify-content: space-around;
          width: 100%;

          .text {
            max-width: 222px;
            margin: 0 auto;
          }

          .approve-registration-wrapper-btns {
            flex-direction: column;
          }
        }
      }
    }
  }
`;
export const StyledTermsOfUseWrapper = styled.div`
  .page-inner {
    padding: 50px 0;
  }

  .title {
    margin: 0;
    margin-bottom: 5px;
    font-size: 42px;
    font-weight: 500;
    line-height: 60px;
    color: ${(props) => props.theme.darkGrayishBlue};
  }

  .sub-title {
    margin: 0;
    margin-bottom: 25px;
    font-size: 20px;
    font-weight: 500;
    line-height: 21px;
    color: ${(props) => props.theme.darkGrayishBlue};
  }

  .contnet span {
    display: block;
    margin-bottom: 10px;
    font-size: 18px;
    line-height: 20px;
    color: ${(props) => props.theme.darkGrayishBlue};
  }
`;

export const StyledEmailConfirmContainer = styled('div')`
  padding: 30px 36px;
  background: ${(props) => props.theme.white};

  display: flex;
  height: 100%;
  flex-grow: 1;

  border-radius: 0 16px 16px 0;

  .ant-form {
    width: 100%;

    .ant-form-item-row,
    .ant-form-item {
      display: flex;
      flex-grow: 1;
      flex-direction: column !important;
    }
  }

  .button-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .ant-btn {
    border-radius: 5px;
    height: 55px;

    &.ant-btn-variant-text {
      border: 1px solid ${(props) => props.theme.brand01};
    }
  }

  @media only screen and (max-width: ${breakpoints.sm}px) {
    .ant-flex {
      flex-direction: column;
      gap: 0px !important;

      .ant-form-item {
        width: 100%;
      }
    }
  }
`;

export const StyledMobileAuthEntry = styled.div`
  min-height: 100vh;
  padding: 0;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${({ theme }) => theme.fontText};

  .mobile-auth-entry-container {
    width: 100%;
    height: 100vh;
    border-radius: 0;
    overflow: hidden;
    position: relative;
    background-image: url('/man-farmland-with-watering-can.png');
    background-size: cover;
    background-position: center top;
  }

  .mobile-auth-entry-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.06) 0%,
      rgba(0, 0, 0, 0.15) 65%,
      rgba(0, 0, 0, 0.22) 100%
    );
  }

  .mobile-auth-entry-logo {
    position: absolute;
    top: 105px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
    width: 160px;
    display: flex;
    justify-content: center;

    img {
      width: 100%;
      display: block;
    }
  }

  .mobile-auth-entry-actions {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.08) 45%,
      rgba(0, 0, 0, 0.16) 100%
    );
  }

  .mobile-auth-entry-actions .ant-btn {
    width: 100%;
    height: 55px;
    border-radius: 5px;
    font-weight: 600;
    background: ${({ theme }) => theme.brand01};
    border: 1px solid ${({ theme }) => theme.brand01};
    color: ${({ theme }) => theme.white};
    box-shadow: none;
  }

  .mobile-auth-entry-actions .ant-btn:hover {
    background: ${({ theme }) => theme.brand01};
    border: 1px solid ${({ theme }) => theme.brand01};
    color: ${({ theme }) => theme.white};
    box-shadow: none;
  }

  .mobile-auth-entry-actions .ant-btn.login {
    background: ${({ theme }) => theme.white};
    border: 1px solid ${({ theme }) => theme.white};
    color: ${({ theme }) => theme.brand01};
  }

  .mobile-auth-entry-actions .ant-btn.login:hover {
    background: ${({ theme }) => theme.white};
    border: 1px solid ${({ theme }) => theme.white};
    color: ${({ theme }) => theme.brand01};
  }

  @media only screen and (max-width: ${breakpoints.sm}px) {
    .mobile-auth-entry-logo {
      top: 88px;
      width: 148px;
    }

    .mobile-auth-entry-actions {
      padding: 14px 16px 12px;
    }
  }
`;
